import { LkmAppealDetail } from 'feature/lkmAppeals/components/lkmAppealDetail/LkmAppealDetail'
import { MainLayout } from 'layouts'

export function LkmOrderDetailPage() {
  return (
    <MainLayout>
      <div className='container'>
        <LkmAppealDetail />
      </div>
    </MainLayout>
  )
}
